module.exports = __webpack_public_path__ + "static/media/share_clippy.240a81d2.svg";